import React,{useState} from 'react'
import logo from "../../assets/boxxdocks-logo-grey.svg"
import { useDispatch, useSelector } from "react-redux";
import { setStateRefresh } from "../../redux/globalSlice";

const AddComment = () => {
  const dispatch = useDispatch();
  const stateRefresh = useSelector((state) => state.global.stateRefresh);
  const [comment, setComment] = useState('');
const submitHandler = () => {
    localStorage.setItem("serviceComment", comment);
    localStorage.setItem("getServicePage", "AddPhoto");
    dispatch(setStateRefresh(!stateRefresh));
  };

  // Skip button
  const handleSkip = () => {
    localStorage.setItem("serviceComment", ""); // Or remove: localStorage.removeItem("comment");
    localStorage.setItem("getServicePage", "AddPhoto");
    dispatch(setStateRefresh(!stateRefresh));
  };
      const maxChars = 200;
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          <div className="main-content">
            <div className="logo mx-auto">
              <img src={logo} className="img-fluid mx-auto" alt="" />
            </div>
            <p className="mb-0 heading">Add Your Comment</p>

            <div className="code-box">
              <form>
                <div className="form-one mb-3">

                  <textarea name="" className='code' rows={10} 
                  placeholder='Enter Comment Here' id=""
                  value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    maxLength={maxChars}
                  />
                 <p className="mb-0 max-red text-muted mt-2" > {comment?.length > 0 ? comment?.length : 0} / {maxChars}</p>
                </div>


                <div className="button-box">
                  <div className="position-absolute">
                    <button type="button" className="btn-skip-s me-4" onClick={handleSkip} >Skip</button>
                    <button type="button" className="btn-continue-s" onClick={submitHandler}>continue</button>

                  </div>
                </div>
              </form>

            </div>



          </div>
        </div>
      </div>
    </div>
  )
}

export default AddComment